/**
 * Angular dependencies
 */
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/**
 * App dependencies
 */
import { FileManagerDrawerComponent } from '@app/shared/components/file-manager/drawer/file-manager-drawer.component';
import { FileManagerComponent } from '@app/shared/components/file-manager/file-manager.component';
import { FileManagerModalComponent } from '@app/shared/components/file-manager/modal/file-manager-modal.component';
import { FileManagerMyDocsComponent } from '@app/shared/components/file-manager/my-docs/file-manager-my-docs.component';
import {
  FileManagerSelectedFilesComponent
} from '@app/shared/components/file-manager/selected-files/file-manager-selected-files.component';
import { FileManagerUploadComponent } from '@app/shared/components/file-manager/upload/file-manager-upload.component';
import { SharedModule } from '@app/shared/shared.module';
import { GeneAiUiModule } from '@gene-ai/ui/gene-ai-ui.module';
import {
  UploadedFilesBannerManagerComponent
} from "@shared/components/file-manager/uploaded-files-banner-manager/uploaded-files-banner-manager.component";
import { FileManagerActionControlsComponent } from './action-controls/file-manager-action-controls.component';
import { FileTypeButtonComponent } from './file-type-button/file-type-button.component';
import { FileManagerAcknowledgementModalComponent } from './modal/file-manager-acknowledgement-modal/file-manager-acknowledgement-modal.component';
import { FileManagerConfirmationModalComponent } from './modal/file-manager-confirmation-modal/file-manager-confirmation-modal.component';



@NgModule({
  declarations: [
    FileManagerComponent,
    FileManagerModalComponent,
    FileManagerDrawerComponent,
    FileManagerMyDocsComponent,
    FileManagerUploadComponent,
    FileManagerSelectedFilesComponent,
    FileManagerActionControlsComponent,
    FileManagerConfirmationModalComponent,
    FileManagerAcknowledgementModalComponent,
    FileTypeButtonComponent,
    UploadedFilesBannerManagerComponent,
  ],
  exports: [
    FileManagerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GeneAiUiModule,
    SharedModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class FileManagerModule { }
